import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ITipoIdentificacion } from '../../shared/interfaces/database/seguridad';


@Injectable({
  providedIn: 'root'
})
export class TipoIdentificacionService {
  private readonly baseUrl = `${environment.apiUrl}/api/tipo-identificacion`;

  constructor(private http: HttpClient) { }

  getTipoIdentificaciones(): Observable<ITipoIdentificacion[]> {
    return this.http.get<ITipoIdentificacion[]>(`${this.baseUrl}/public`);
  }
}
